import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from "react-router-dom";
import LanguageSelectorCtrl from './languageSelectorCtrl';
import { getAuth, onAuthStateChanged } from 'firebase/auth';

function Header() {

    const { t } = useTranslation();

    const [authUser, setAuthUser] = useState<any | null>(null);

    useEffect(() => {
        const auth = getAuth();
        onAuthStateChanged(auth, user => {
            if (user) {
                // User is signed in.
                setAuthUser(user);

            } else {
                // User is signed out.
                setAuthUser(null);
            }
        });

    }, []);


    function onLogoutButtonClick() {
        const auth = getAuth();
        auth.signOut();
    }


    return <div className="kt-header">

        <img src="/images/logo.svg" width={32} alt="logo" />

        <span className="navbar-brand-name">Pickadoc</span>

        {(authUser && authUser.phoneNumber) ?
            <div className="kt-header-buttons">
                <Link to={'/appointments'} className="kt-logout-button"><i className="fal fa-calendar-alt"></i> <span className="kt-hide-on-mobile">{t("appointments")}</span></Link>
                <div className="kt-logout-button" onClick={onLogoutButtonClick}><i className="fal fa-sign-out-alt"></i> <span className="kt-hide-on-mobile">{t("components.buttons.logout")}</span></div>
            </div>
            :
            <Link
                to={"/login-register"}
                className="kt-login-button"
                style={{ justifySelf: "end" }}
            >
                <i className="fal fa-sign-in-alt"></i> {t("components.buttons.login")}
            </Link>
        }

        <div style={{ justifySelf: "end" }}><LanguageSelectorCtrl flagWidth={20} /></div>

    </div>

}

export default Header;